import React from "react";
import Grid from "@mui/material/Grid";

import TextInput from "./inputs/TextInput";
import SelectInput from "./inputs/SelectInput";
import CheckboxInput from "./inputs/CheckboxInput";
import AmountInput from "./inputs/AmountInput";
import PlanSubscriptionSelectInput from "./inputs/PlanSubscriptionSelectInput";

const DynamicForm = ({ inputs, values, onChange }) => {
  return (
    <Grid container spacing={2}>
      {inputs.map((input) => {
        const commonProps = {
          id: input._key,
          name: input._key,
          label: input._name,
          value: values[input._key],
          onChange: onChange,
          required: input._mandatory,
          helperText: input._helperText,
        };

        return (
          <Grid item xs={12} sm={input._gridSize || 12} key={input._key}>
            {input._type === "text" ||
            input._type === "number" ||
            input._type === "password" ||
            input._type === "date" ? (
              <TextInput
                {...commonProps}
                options={input._options}
                placeholder={input._placeholder}
                type={input._type}
              />
            ) : null}

            {input._type === "amount" && (
              <AmountInput
                {...commonProps}
                options={input._options}
                placeholder={input._placeholder}
              />
            )}

            {input._type === "drop-down" && (
              <SelectInput
                {...commonProps}
                options={input._options.options || []}
              />
            )}

            {input._type === "subscription-drop-down" && (
              <PlanSubscriptionSelectInput
                {...commonProps}
                options={input._options.options || []}
              />
            )}

            {/* Custom Drop - Down */}
            {input._type === "dynamic-drop-down" && (
              <SelectInput {...commonProps} options={input._options || []} />
            )}

            {input._type === "checkbox" && (
              <CheckboxInput
                name={input._key}
                label={input._name}
                checked={values[input._key]}
                onChange={onChange}
                required={input._mandatory}
              />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default DynamicForm;
